import type { CookieConsentConfig } from '@teamnovu/kit-cookieconsent'
import {
  createCookieConsent,
  useCookieConsent,
} from '@teamnovu/kit-cookieconsent'
import cookieConsentTranslations from '../utils/cookieconsent-translations'

const updateGtagOptions = (services: any) => {
  const { gtag } = useGtag()
  gtag('consent', 'update', {
    analytics_storage: services.analytics ? 'granted' : 'denied',
  })
}

export default defineNuxtPlugin(({ vueApp }) => {
  const consentConfig: CookieConsentConfig = {
    guiOptions: {
      consentModal: {
        layout: 'bar inline',
        position: 'bottom',
        flipButtons: false,
        equalWeightButtons: true,
      },
    },

    categories: {
      necessary: {
        enabled: 1,
        readOnly: 1,
      },
      functional: {
        enabled: 1,
        readOnly: 1,
        services: {},
      },
      analytics: {
        enabled: 0,
        readOnly: 0,
        autoClear: {
          cookies: [{ name: /^_/ }],
        },
      },
    },

    language: {
      default: vueApp.$nuxt.$i18n.locale.value,
      autoDetect: 'document',
      translations: cookieConsentTranslations,
    },
  }

  vueApp.use(createCookieConsent(consentConfig))

  if (import.meta.client) {
    const cookieconsent = useCookieConsent()!

    watch(
      cookieconsent.services,
      (services) => {
        updateGtagOptions(services)
      },
      { immediate: true },
    )
  }
})
